import InventoryRequireRoute from "./InventoryRequireRoute";

export default InventoryRequireRoute;
